module.exports = __webpack_public_path__ + "static/media/metodo.6648a806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/metodo.png
// module id = 1203
// module chunks = 0